import { render, staticRenderFns } from "./com-search.vue?vue&type=template&id=9b9bd144&scoped=true&"
import script from "./com-search.vue?vue&type=script&lang=js&"
export * from "./com-search.vue?vue&type=script&lang=js&"
import style0 from "./com-search.vue?vue&type=style&index=0&id=9b9bd144&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9bd144",
  null
  
)

export default component.exports